
// Header should be sticky when past 200% of header height moving towards the top

// Header should hide when moving down the page

// Sticky header should be reduced content
const header = document.querySelector('.header-wrapper')
let direction = null
let y = 0

window.addEventListener('scroll', e => {

    if(window.scrollY > header.getBoundingClientRect().height) {
        document.body.classList.add('sticky-header')
        // document.body.classList.add('mini-header')

        if (y > window.scrollY) {
            document.body.classList.add('sticky-visible')
            document.body.classList.add('mini-header')
        } else {
            document.body.classList.remove('sticky-visible')
        }
    }

    if(window.scrollY < 5) {
        document.body.classList.remove('sticky-visible')
        document.body.classList.remove('sticky-header')
        document.body.classList.remove('mini-header')
    }

    y = window.scrollY
})